import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen.ts";
import { getAccessTokenSync } from "@/utils/storage/authStorage.ts";

export const router = createRouter({
	routeTree,
	context: {
		token: typeof window !== "undefined" ? getAccessTokenSync() : null,
	} as { token: string | null },
});

declare module "@tanstack/react-router" {
	interface Register {
		// This infers the type of our router and registers it across your entire project
		router: typeof router;
	}
}

